interface StatusBadgeProps {
  status: string;
  size?: 'sm' | 'md' | 'lg';
}

const STATUS_CONFIG: Record<string, { label: string; color: string; bgColor: string }> = {
  prospect: {
    label: 'Prospect',
    color: 'text-info',
    bgColor: 'bg-info-wash',
  },
  contacted: {
    label: 'Contacted',
    color: 'text-gray-800',
    bgColor: 'bg-gray-100',
  },
  pitched: {
    label: 'Pitched',
    color: 'text-info',
    bgColor: 'bg-info-wash',
  },
  listed: {
    label: 'Listed',
    color: 'text-success',
    bgColor: 'bg-success-wash',
  },
  under_contract: {
    label: 'Under Contract',
    color: 'text-warning',
    bgColor: 'bg-warning-wash',
  },
  sold: {
    label: 'Sold',
    color: 'text-success',
    bgColor: 'bg-success-wash',
  },
  dead: {
    label: 'Dead',
    color: 'text-gray-700',
    bgColor: 'bg-gray-200',
  },
  watch: {
    label: 'Watching',
    color: 'text-warning',
    bgColor: 'bg-warning-wash',
  },
};

const SIZE_CLASSES = {
  sm: 'text-[11px] px-2.5 py-1',
  md: 'text-[11px] px-2.5 py-1',
  lg: 'text-xs px-3 py-1.5',
};

export default function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const config = STATUS_CONFIG[status] || {
    label: status,
    color: 'text-gray-700',
    bgColor: 'bg-gray-100',
  };

  return (
    <span
      className={`inline-flex items-center font-semibold leading-none rounded-full ${config.bgColor} ${config.color} ${SIZE_CLASSES[size]}`}
    >
      {config.label}
    </span>
  );
}

// Export status options for select dropdowns
export const STATUS_OPTIONS = [
  { value: 'prospect', label: 'Prospect' },
  { value: 'contacted', label: 'Contacted' },
  { value: 'pitched', label: 'Pitched' },
  { value: 'listed', label: 'Listed' },
  { value: 'under_contract', label: 'Under Contract' },
  { value: 'sold', label: 'Sold' },
  { value: 'dead', label: 'Dead' },
  { value: 'watch', label: 'Watching' },
];
